<template>
  <div class="w1300">
    <div class="banner">
    <div class="swiper-container" >
      <div class="swiper-wrapper">
        <div v-for="item in bannerList" :key="item.id" class="swiper-slide" >
          <!-- <img src="../assets/images/4.jpg" alt="" /> -->
          <img :src="imgUrl + item.image" alt="" @click="goUrl(item.webUrl)"/>
        </div>
      </div>
      <div class="swiper-pagination"></div>
      <!-- <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div> -->
    </div>
  </div>
  </div>
</template>
<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {
      bannerList: [],
      imgUrl: this.$imgUrl,
    };
  },
  mounted() {
    this.getBanner();
    setTimeout(()=>{
      this.getSwiper();
    },100)
    
  },

  methods: {
    getSwiper() {
      this.swiper = new Swiper(".swiper-container", {
        loop: true, // 无缝
        autoplay: {
          //自动开始
          delay: 3000, //时间间隔
          disableOnInteraction: false, //*手动操作轮播图后不会暂停*
        },
        paginationClickable: true,
        slidesPerView: 1, // 一组三个
        spaceBetween: 30, // 间隔
        // 如果需要前进后退按钮
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        // 如果需要分页器
        pagination: {
          el: ".swiper-pagination",
          clickable: true, // 分页器可以点击
        },
      });
     

    },
    getBanner() {
      this.$get("/web/index/banner").then((res) => {
        if (res.code == 200) {
          this.bannerList = res.rows
        }
      });
    },
    goUrl(url){
      if(url !=""){
        window.open(url,"_blank")
      }
    }
  },
};
</script>
<style scoped>
.banner {
  margin-top: 15px;
}
.banner img {
  width: 100%;
  /* height: 475px; */
}
/deep/ .swiper-pagination-bullet{background: #fff;}
</style>
